module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB8AAAAVBAMAAABMGyhsAAAAMFBMVEUAAAB4eHiAgIB9fX2AgIB+fn59fX1+fn5+fn5/f39+fn59fX1+fn5+fn5+fn5+fn72T/zDAAAAD3RSTlMAESIzRFVmd4iZqrvM3e5GKvWZAAAA1ElEQVQY02Ow2o0MdggwvP+PAhYwoPL/bwAJ/JvmPu//3zb39TCBQgYGxvkJDAxM6yEC3xiAYHsBkOCECICY7A4tIOH9IIG/IJYkgxSIsgcJfFdWZmAIYWB1F2BgqAEJfKk+UVq5fFrb9mrNqh1ggdXba7YuX320IGbV8Wlggd2z53Rdn7rp+O62neVgM4yNjB2djIyMjQ2VpeC2cDNwgSh9uDtYC8JBAuvBAp9BzGkNQIIN6heQkvoGkIegAn9bXPv+/2sDehkqgBoeGCEWjRKmuwQA8iHIj5D83aAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/static/img/f-mc.png
// module id = 751
// module chunks = 0